"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKLoadingType = void 0;
/** Used by GKLoading to determine which style of loading animation it should render. */
var GKLoadingType;
(function (GKLoadingType) {
    GKLoadingType["None"] = "none";
    GKLoadingType["Spinner"] = "spinner";
    GKLoadingType["Bar"] = "bar";
})(GKLoadingType = exports.GKLoadingType || (exports.GKLoadingType = {}));
